// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../../components/Button';
import Tooltip from './TooltipImage';
import BannerImage from '../assets/problem-banner.png';
import Dropdown from './Dropdown';
import ReplyField from '../ReplyFIeld';

const S = {
  Form: styled.form`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  `,
  Container: styled.div`
    display: flex;
    flex-direction: column;
  `,
  MessageContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
    background: #FFFFFF;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.161);
    border-radius: 4px;
    padding: 24px;
  `,
  Image: styled.img`
    height: 100%;
  `,
  TitleText: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 22px;
    line-height: 32px;
    text-align: center;
    color: #313131;
    margin-bottom: 14px;
    margin-top: 24px;
  `,
  DescriptionText: styled.div`
    justify-content: center;
    align-items: center;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #313131;
    margin-bottom: 28px;
  `,
  Banner: styled.div`
    padding: 42px 31px;
    background-image: url(${BannerImage});
    background-position: right bottom;
    background-repeat: no-repeat;
  `,
  BannerText: styled.p`
    font-weight: bold;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
  `,
  NewSupportField: styled.div`
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.161);
    border-radius: 4px;
    padding: 24px;
    flex-grow:1;
  `,
  Wrapper: styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-grow: 1;
  `,
  NewSupportFieldHeaderWrapper: styled.div`
    display: flex;
    align-items: center;
  `,
  NewSupportFieldHeaderIcon: styled.img`
    margin-left: 16px;
  `,
  NewSupportFieldTitle: styled.div`
    margin-left: 12px;
    margin-right: 12px;
    font-weight: bold;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
  `,
  Dropdown: styled(Dropdown)`
    margin-left: auto;
  `,
  TitleSupportInput: styled.input<{ error?: string }>`
    margin-top: 24px;
    width: 100%;
    color: #434343;
    outline: none;
    background: rgba(239, 239, 239, 0.5);
    border-radius: 4px;
    padding: 14px 18px;
    font-size: 16px;
    line-height: 23px;

    &::placeholder {
      color: #A6A6A6;
    }
  `,
  ReplyField: styled(ReplyField)`
  `,
  ErrorText: styled.p`
    color: red;
    font-size: 12px;
    line-height: 18px;
  `,
  Text: styled.p`
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;
    letter-spacing: 0.29px;
    color: #000000;
  `,
  Resend: styled.a`
    color: #EF8200;
    cursor: pointer;
    text-decoration-line: underline;
    text-underline-offset: 2px;
  `,
  IconWrapper: styled.div`
    position: absolute;
    top: 0px;
    z-index: 10;
    right: -12px;
    width: auto;
    height: auto;
    overflow: initial;
  `,
  ButtonBackDefault: styled(Button)`
    cursor: pointer;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    width: 142px;
    height: 44px;
`,
};

export { S as default };

